import { render, staticRenderFns } from "./AddCollaboratorConfig.vue?vue&type=template&id=110791be&scoped=true"
import script from "./AddCollaboratorConfig.vue?vue&type=script&lang=js"
export * from "./AddCollaboratorConfig.vue?vue&type=script&lang=js"
import style0 from "./AddCollaboratorConfig.vue?vue&type=style&index=0&id=110791be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110791be",
  null
  
)

export default component.exports